export const listPath = [
    {
        name: 'Главная',
        path: '/',
    },
    {
        name: 'Кейсы',
        path: '/cases',
    },
    {
        name: 'Разработка',
        path: '/cases/development',
    },
];

export const listTitle = [
    {
        title: 'Цифровизация рынка долевого строительства',
        description: [
            {
                name: 'Клиент',
                details: 'Фонд развития территорий',
            },
            {
                name: 'Отрасль',
                details: 'Социальная сфера',
            },
            {
                name: 'Услуги',
                details: 'Разработка новых сервисов и&nbsp;техническая поддержка платформы',
            },
            {
                name: 'Технологии',
                details: 'PHP, Bitrix, Sentry',
            },
        ],
    },
];
